import React, {useState, useEffect} from "react";
import PropTypes from "prop-types";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";

const initialState = {
  name: "New Definition Group",
  nameError: "",
};

function nameAlreadyExists(name, definitionGroups) {
  const foundDg = definitionGroups.find(
    dg => dg.name.toLowerCase() === name.toLowerCase(),
  );
  return Boolean(foundDg);
}

function CreateDefinitionGroup(props) {
  const {addDefinitionGroup} = props;
  const [{name, nameError}, setState] = useState(initialState);

  const clearState = () => {
    setState({...initialState});
  };

  useEffect(
    () => {
      clearState();
    },
    [props.createDialogShown],
  );

  const setStateValue = (name, value) =>
    setState(prevState => ({...prevState, [name]: value}));

  const onNameChange = e => setStateValue("name", e.target.value);
  const validateName = e => {
    if (e.target.value.length === 0) {
      setStateValue("nameError", "You must set definition group name");
    } else {
      setStateValue("nameError", "");
    }
  };

  const addNewDefinitionGroupHandler = () => {
    if (
      name.toLowerCase() === "new definition group" ||
      nameAlreadyExists(name, props.definitionGroups)
    ) {
      setStateValue(
        "nameError",
        "Please specify different definition group name",
      );
    } else {
      addDefinitionGroup({name});
      props.onHideCreateDialog();
    }
  };

  return (
    <Dialog
      fullWidth
      onClose={props.onHideCreateDialog}
      open={props.createDialogShown}
    >
      <DialogTitle>Create new Definition Group</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          label="Definition Group Name"
          helperText={nameError}
          error={Boolean(nameError)}
          value={name}
          onChange={onNameChange}
          onBlur={validateName}
        />
      </DialogContent>
      <DialogActions>
        <Button
          key="create-definition-group-dialog-cancel-button"
          onClick={props.onHideCreateDialog}
        >
          Cancel
        </Button>
        <Button
          key="create-definition-group-dialog-create-button"
          color="primary"
          onClick={addNewDefinitionGroupHandler}
        >
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
}

CreateDefinitionGroup.propTypes = {
  definitionGroups: PropTypes.array.isRequired,
  onHideCreateDialog: PropTypes.func.isRequired,
  createDialogShown: PropTypes.bool.isRequired,
  addDefinitionGroup: PropTypes.func.isRequired,
};

export default CreateDefinitionGroup;
